<template>
  <div class="filters">
    <div class="filters__mobile-toggles">
      <button
        class="filters__open-filters"
        @click.prevent="toggleMobileFilters"
      >
        {{ $t('filters.button') }}
      </button>
      <products-sort class="filters__products-sort" />
    </div>

    <div
      :class="[this.isActiveOnMobile ? 'filters__wrapper--mobile-active' : 'filters__wrapper']"
    >
      <div class="filters__header">
        <span
          class="filters__mobile-close-button"
          @click="toggleMobileFilters"
          role="button"
          tabindex="0"
          @keydown="handleKeyDown"
        />
        <span class="filters__name">{{ $t('filters.headline') }}</span>
      </div>
      <div class="filters__list">
        <div
          v-for="(filter) in filters"
          :key="filter.name"
          class="filters__filter"
          v-show="show(filter)"
        >
          <button
            class="filters__filter-toggle"
            type="button"
            :class="{
              'filters__filter-toggle--active': filter.activeOptions.length
            }"
            @click.prevent="(event) => event.target.nextElementSibling.classList.toggle('opened')"
          >
            {{ filter.label }}
          </button>

          <div
            class="filters__filter-dropdown"
            ref="filterDropdown"
            :class="{
              'filters__filter-dropdown--price': filter.type === 'price',
            }"
          >
            <template v-if="filter.type === 'price'">
              <filter-price
                :name="filter.name"
              />
            </template>
            <template v-else-if="filter.type === 'rating'">
              <filter-rating
                :name="filter.name"
              />
            </template>
            <template v-else>
              <filter-vue
                :name="filter.name"
              />
            </template>
          </div>
        </div>
      </div>
      <div
        class="filters__footer"
        v-show="activeFilters.length > 0"
      >
        <button
          class="filters__apply-button"
          @click="toggleMobileFilters"
        >
          {{ $t('filters.apply') }}
        </button>
        <span
          class="filters__clear-all-button"
          @click="removeAllClickHandler"
          role="button"
          tabindex="0"
          @keydown="handleKeyDown"
          :aria-label="$t('global.filter.mobile.remove.all.aria.label')"
        >
          {{ $t('productlist.filter.list.reset.button') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import plpStateComputedMixin from '../../utilities/vueMixins/plpStateComputedMixin/plpStateComputedMixin.js'
import FilterVue from '../filter/filter.vue'
import FilterPrice from '../filterPrice/filterPrice.vue'
import FilterRating from '../filterRating/filterRating.vue'
import ProductsSort from '../productsSort/productsSort.vue'

export default {
  mixins: [
    plpStateComputedMixin,
  ],
  components: {
    FilterVue,
    FilterPrice,
    ProductsSort,
    FilterRating
  },
  data() {
    return {
      isActiveOnMobile: false,
      updatePageOnChange: {
        type: Boolean,
        default: true
      }
    }
  },
  mounted() {
    // expand all active filters
    const self = this;
    this.activeFilters.forEach(active => {
      const index = self.filters.findIndex(filter => filter.name === active.name);
      self.$refs.filterDropdown[index].classList.add('opened');
    })
  },
  methods: {
    toggleMobileFilters() {
      this.isActiveOnMobile = !this.isActiveOnMobile
    },
    removeAllClickHandler() {
      this.$store.dispatch('productsListPage/removeAllActiveFilterOptions', {
        updatePageOnChange: this.updatePageOnChange
      })
    },
    show(filter) {
      return filter.type === 'price' || (filter.type !== 'price' && filter.options.filter(option => option.count).length)
    },
    handleKeyDown(event) {
      if (event.key === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        event.target.click();
      }
    }
  }
}

</script>
